module.exports = __webpack_public_path__ + "files/01c314ecd8240f26e74f4f519ff9340b.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/objects-3.png
// module id = 521
// module chunks = 76